"use client";

import posthog from "posthog-js";
import { PostHogProvider } from "@posthog/react";
import { useEffect } from "react";
import { env } from "@/lib/env";

declare global {
	interface Window {
		__lovepagePosthogInitialized?: boolean;
	}
}

function ensurePosthogInitialized() {
	if (typeof window === "undefined") return;
	if (window.__lovepagePosthogInitialized) return;

	posthog.init(env.NEXT_PUBLIC_POSTHOG_KEY, {
		api_host: env.NEXT_PUBLIC_POSTHOG_HOST,
		capture_pageview: true,
		capture_pageleave: true,
		__add_tracing_headers: ["lovpage.com.br"],
	});
	window.__lovepagePosthogInitialized = true;
}

export function PHProvider({ children }: { children: React.ReactNode }) {
	useEffect(() => {
		ensurePosthogInitialized();
	}, []);

	return <PostHogProvider client={posthog}>{children}</PostHogProvider>;
}
